import gql from "graphql-tag";
import { coro } from '../configuration/colors';

/**
 * Class KnowledgeManager.js
 *
 * @class KnowledgeManager
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/manager/KnowledgeManager.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export class KnowledgeManager {
  constructor(
    apolloMobileClient,
    store
  ) {
    /** @type ApolloClient */
    this.apolloMobileClient = apolloMobileClient;

    this.store = store
  }

  getPatientTestSummary(patientId, knowledgeLevel) {
    return this.apolloMobileClient
      .query({
        query: gql`query getPatientTestSummary($patientId : String!, $knowledgeLevel : String!)
        {
            myPatientTestSummary(
                functions : {function : patientId, parameters : [$patientId]}
                conditions : {gate : and, inputs : [
                    {field : knowledgeLevel, value : $knowledgeLevel}
                    {field : completionDate, operator : notnull}
                ]}
                groups : [knowledgeDomain]
            ){
                groupKey0
                groupKey1
                numberOfQuestions
                numberOfCorrectQuestions
                scorePercent
                totalTimeSpent
                averageTimeSpent
            }
        }
      `,
        variables: { patientId, knowledgeLevel },
      }).then(result => {
        return result.data.myPatientTestSummary
      })
  }

  poll() {
    return this.apolloMobileClient
        .query({
          query: gql`query poll
      {
          poll
      }
      `,
          variables: {},
        }).then(result => {
          return result.data.poll
        })
  }

  getColorForKnowledgeLevel(knowledgeLevel = 1) {
    return levelColors[parseInt(knowledgeLevel) - 1];
  }

  getKnowledgeCategories(patientId) {
    if (!patientId) {
      patientId = this.store.getters['patientSummary/id'];
    }

    if (!patientId) {
      return Promise.resolve([]);
    }

    return this.apolloMobileClient
        .query({
          query: gql`query getVideoCategories($patientId : String!)
        {
          myCategories(
            functions : [{function : patientId, parameters : [$patientId]}]
            conditions : {gate : or, inputs : [
                {field : type, operator : in,  parameters : ["BEHAVIOUR_COMPONENT", "OUTCOME_GOAL"]},
                {field : key, operator : in, parameters : ["MYHEART", "MYSOCIALENVIRONMENT"]}
            ]}){
              favouredDocumentCount
              recommendedDocumentCount
              selectedTopicDocumentCount

              category{
                key
                name
              }
            }
        }
        `,
          variables: {
            patientId
          }
        }).then(result => {
          return result.data.myCategories
        })
  }
}

export const levelColors = [coro['warning-500'], coro['info-500'], coro['success-500']];